import { call, put, takeLatest } from 'redux-saga/effects';
import {
  ADD_CUSTOMER_REQUEST,
  FETCH_CUSTOMERS_REQUEST,
  UPDATE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_REQUEST,
  FETCH_CUSTOMER_DETAILS_REQUEST,
  FETCH_ALL_CUSTOMERS_REQUEST,
} from '../types/customerTypes';
import {
  addCustomerSuccess,
  addCustomerFailure,
  fetchCustomersSuccess,
  fetchCustomersFailure,
  updateCustomerSuccess,
  updateCustomerFailure,
  deleteCustomerSuccess,
  deleteCustomerFailure,
  fetchCustomerDetailsSuccess,
  fetchCustomerDetailsFailure,
  fetchAllCustomersSuccess,
  fetchAllCustomersFailure,
} from '../actions/customerActions';
import axiosInstance from '../../instance/AxiosInstance';
import AxiosInstanceUnauthorized from '../../instance/AxiosInstanceUnauthorized';
function* handleAddCustomer(action) {
  try {
    const response = yield call(
      axiosInstance.post,
      '/customers/insertcustomer',
      action.payload
    );
    console.log('response', response);
    yield put(addCustomerSuccess(response.data));
  } catch (error) {
    const errorDetails = error.response?.data || {};
    const additionalErrors = errorDetails.additionalErrors || {};
    const message = errorDetails.message || 'Failed to add customer';
    yield put(
      addCustomerFailure({
        message,
        additionalErrors,
      })
    );
  }
}
function* handleFetchCustomers(action) {
  const { payload } = action;
  if (!payload || !payload.pagesize || !payload.pageNo) {
    yield put(fetchCustomersFailure('Invalid payload'));
    return;
  }
  try {
    const response = yield call(
      axiosInstance.get,
      `/customers/list?pagination_required=true&pagesize=${payload.pagesize}&pageNo=${payload.pageNo}`
    );
    yield put(fetchCustomersSuccess(response.data));
  } catch (error) {
    yield put(
      fetchCustomersFailure(
        error.response?.data?.message || 'Failed to fetch customers'
      )
    );
  }
}
// fetch all customer
function* handleFetchAllCustomers() {
  try {
    const response = yield call(axiosInstance.get, `/customers/list?`);
    yield put(fetchAllCustomersSuccess(response.data));
  } catch (error) {
    yield put(
      fetchAllCustomersFailure(
        error.response?.data?.message || 'Failed to fetch customers'
      )
    );
  }
}
function* handleUpdateCustomer(action) {
  try {
    const response = yield call(
      axiosInstance.put,
      `customers/updatecustomer/${action.payload.id}`,
      action.payload
    );
    console.log(response);
    yield put(updateCustomerSuccess(response.data));
  } catch (error) {
    yield put(
      updateCustomerFailure(
        error.response?.data?.message || 'Failed to update customer'
      )
    );
  }
}
function* handleDeleteCustomer(action) {
  try {
    yield call(
      axiosInstance.delete,
      `/customers/deletecustomer/${action.payload}`
    );
    yield put(deleteCustomerSuccess(action.payload));
  } catch (error) {
    yield put(
      deleteCustomerFailure(
        error.response?.data?.message || 'Failed to delete customer'
      )
    );
  }
}
function* handleFetchCustomerDetails(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      `/customers/getcustomer?customer_id=${action.payload}`
    );
    if (response.data) {
      yield put(fetchCustomerDetailsSuccess(response.data));
    } else {
      throw new Error('Customer details not found.');
    }
  } catch (error) {
    yield put(
      fetchCustomerDetailsFailure(
        error.response?.data?.message || 'Error fetching customer details.'
      )
    );
  }
}
export function* watchCustomerActions() {
  yield takeLatest(ADD_CUSTOMER_REQUEST, handleAddCustomer);
  yield takeLatest(FETCH_CUSTOMERS_REQUEST, handleFetchCustomers);
  yield takeLatest(UPDATE_CUSTOMER_REQUEST, handleUpdateCustomer);
  yield takeLatest(DELETE_CUSTOMER_REQUEST, handleDeleteCustomer);
  yield takeLatest(FETCH_CUSTOMER_DETAILS_REQUEST, handleFetchCustomerDetails);
  yield takeLatest(FETCH_ALL_CUSTOMERS_REQUEST, handleFetchAllCustomers);
}
